var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
export class ChoiceInfo {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get question() {
        return this.parent;
    }
    get hasMultipleCorrectOptions() {
        // console.log(this.question.options, this.question);
        return this.question.options.filter(option => option.shouldBeSelected).length > 1;
    }
    get hasOnlySingleCorrectOption() {
        return !this.hasMultipleCorrectOptions;
    }
    get optionsToBeSelected() {
        return this.question.options.filter(o => o.shouldBeSelected);
    }
    get optionsToLeaveUnselected() {
        return this.question.options.filter(o => !o.shouldBeSelected);
    }
    get numberOfFalseOptions() {
        return this.question.options.filter(o => !o.shouldBeSelected).length;
    }
}
__decorate([
    computed
], ChoiceInfo.prototype, "hasMultipleCorrectOptions", null);
